import { LanguagePair } from '@/entities/glossary';

import { Glossary } from '@/shared/api/glossary/types';
import { createModalStore } from '@/shared/lib/modal';
import { Project } from '@/shared/types/Project';

type View = 'createGlossary' | 'editGlossary' | 'retranslateProject';

type UseGlossaryModalStore = {
  dstLang?: LanguagePair['dstLang'];
  glossaryId?: Glossary['id'];
  isEditViewFormUpdated?: boolean;
  projectId?: Project['id'];
  shouldSubmitUnsavedChanges?: boolean;
  srcLang?: LanguagePair['srcLang'];
  view: View;
};

const INITIAL_VALUES = {
  dstLang: undefined,
  glossaryId: undefined,
  isEditViewFormUpdated: false,
  projectId: undefined,
  shouldSubmitUnsavedChanges: false,
  srcLang: undefined,
  view: 'createGlossary',
} as const;

export const useGlossaryModalStore = createModalStore<UseGlossaryModalStore>(INITIAL_VALUES);

export const setGlossaryModalView = (view: View) => useGlossaryModalStore.setState({ view });
export const setGlossaryId = (glossaryId: Glossary['id']) => useGlossaryModalStore.setState({ glossaryId });
export const setShouldSubmitUnsavedChanges = (shouldSubmitUnsavedChanges: boolean) =>
  useGlossaryModalStore.setState({ shouldSubmitUnsavedChanges });
export const setIsEditViewFormUpdated = (isEditViewFormUpdated: boolean) =>
  useGlossaryModalStore.setState({ isEditViewFormUpdated });
